class ReadingProgress extends HTMLElement {
  connectedCallback() {
    this.bar = this.querySelector('[data-progress-bar]');
    if (!this.bar) return;

    this.contentSelector = this.getAttribute('content-selector') || '.blog-post-content';
    this._onScroll = this._update.bind(this);
    window.addEventListener('scroll', this._onScroll, { passive: true });
    this._update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
  }

  _update() {
    const content = document.querySelector(this.contentSelector);
    if (!content) return;

    // Position bar below the header only when it's visibly on screen
    const header = document.querySelector('#header-component');
    let top = 0;
    if (header) {
      const state = header.getAttribute('data-sticky-state');
      if (state !== 'idle') {
        const rect = header.getBoundingClientRect();
        top = Math.max(rect.bottom, 0);
      }
    }
    this.style.top = `${top}px`;

    // Calculate reading progress through the full article section
    const section = content.closest('.section') || content;
    const rect = section.getBoundingClientRect();
    const total = rect.height - window.innerHeight;
    const progress = total > 0 ? Math.min(Math.max(-rect.top / total, 0), 1) : 0;

    this.bar.style.width = `${progress * 100}%`;
  }
}

customElements.define('reading-progress', ReadingProgress);
